import { render, staticRenderFns } from "./PAPCreditVsDebit.vue?vue&type=template&id=a65f0ba8&scoped=true&"
import script from "./PAPCreditVsDebit.vue?vue&type=script&lang=js&"
export * from "./PAPCreditVsDebit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65f0ba8",
  null
  
)

export default component.exports